import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { Location } from '@angular/common';


@Component({
  selector: 'vehicle-action',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],  
  styles: [`
    .wrapper-route-0 {
      padding-bottom: 70px;
    }           
  `],
  template: `

    <div class="wrapper-route-0">

      <images-scrollview [id]="id"></images-scrollview> 

      <vehicle-info [id]="id" (complete)="onComplete($event)"></vehicle-info>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '314px' }" [align]="{ horizontal: 'start', vertical: 'top' }" positionMode="absolute" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="photo-camera" themeColor="warning" [offset]="{ x: '12px', y: '314px' }" [align]="{ horizontal: 'end', vertical: 'top' }" positionMode="absolute" (click)="goPhotos()" *ngIf="authService.hasPermission(['ENTRADAS_VEHICULOS:EDITAR'])"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="dollar" themeColor="success" [offset]="{ x: '72px', y: '314px' }" [align]="{ horizontal: 'end', vertical: 'top' }" positionMode="absolute" (click)="goCost()" *ngIf="authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:EDITAR']) && vehicle.id_vehicle_status == 1"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="cancel" themeColor="success" [offset]="{ x: '72px', y: '314px' }" [align]="{ horizontal: 'end', vertical: 'top' }" positionMode="absolute" (click)="deleteCost()" *ngIf="authService.hasPermission(['VEHICULOS_COSTOS_GRUAS:ELIMINAR']) && vehicle.id_vehicle_status == 2">
        <ng-template kendoFloatingActionButtonTemplate>
          <span class="k-icon k-i-dollar mail-icon"></span>          
          <kendo-badge size="small" themeColor="error" [align]="{ vertical: 'bottom', horizontal: 'end' }" [cutoutBorder]="true" [position]="'edge'">
            <span class="k-icon k-i-cancel k-badge-icon"></span>
          </kendo-badge>
        </ng-template>
      </kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class VehicleActionsComponent extends PageBaseComponent {
    
  public id: number = 0;

  public vehicle: any = {};

  public table: string = 'vehicles_inventories';

  public returnUrl: string = 'vehicles';
  

  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private dialogService: DialogService, private location: Location) { 

    super(authService, router)
    // console.log('VehicleActionsComponent');
    let id = this.route.snapshot.paramMap.get('id');
    this.id = (id != null) ? parseInt(id): 0;

    let state = location.getState() as {returnUrl: string};
    if(state.returnUrl != null)
      this.returnUrl = state.returnUrl;
    console.log(this.returnUrl);

  }

  public onComplete(event: any) {

    this.vehicle = event.dataItem;

  }

  public goBack() {

    this.router.navigate([`/${this.returnUrl}`]);
  
  }

  public goCost() {

    this.router.navigate([`/vehicle_cost/${this.id}`]);
  
  }

  public goPhotos() {

    this.router.navigate([`/vehicle_photos/${this.id}`]);
  
  }

  public deleteCost() {

    // let that = this;
  
    const dialog: DialogRef = this.dialogService.open({
      title: "Confirmar",
      content: `¿Esta seguro que desea quitar el costo de grúa de ${this.intl.formatNumber(this.vehicle.cost_crane, "c2")}?`,
      actions: [{ text: "No", primary: true }, { text: "Sí" }],
      width: '80%',
      // height: 200,
      // minWidth: 250,
    });
  
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
          // console.log("close");
      }
      else {
        console.log(result);
        if(result.text == 'Sí') {
          this.save();
        }
      }
    });

  }

  public save(): void {
  
    // let that = this;

    let data = {
      id: this.id,
      cost_crane: null,
      id_vehicle_status: 1
    };

    console.log(data);

    this.loading = true;

    this.service.updateRow(this.table, data) 
      .subscribe(
        (res: any) => {
          console.log("PUT Request is successful: ", this.table, data);

          this.loading = false;

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se eliminó con éxito el costo de grúa`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([`/vehicle_actions/${this.id}`]);
            });
            
          });

        },
        (fail: any) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

      
}